import { type RouteDefinition, Router } from '@solidjs/router'
import { QueryClient, QueryClientProvider } from '@tanstack/solid-query'
import { type Component, onMount } from 'solid-js'
import { ServiceRegistry } from 'solid-services'
import Container from './Container'
import SignIn from './SignIn'
import UserTest from './components/UserTest'

import { initApp } from './core/initApp'
import chatRoutes from './routes/Chat/routes'
import dashboardRoutes from './routes/Dashboard/routes'
import potentialHighQualityRoutes from './routes/PotentialHighQuality/routes'
import settingsRoutes from './routes/Settings/routes'
import setupRoutes from './routes/Setups/routes'
import updateRoutes from './routes/Updates/routes'

const routes: RouteDefinition[] = [
  {
    path: '/login',
    component: SignIn,
  },
  {
    path: '/test-api',
    component: UserTest,
  },

  {
    path: '/',
    component: Container,
    children: [
      ...settingsRoutes,
      ...setupRoutes,
      ...chatRoutes,
      ...updateRoutes,
      ...dashboardRoutes,
      ...potentialHighQualityRoutes,
    ],
  },
]

const queryClient = new QueryClient()

const App: Component = () => {
  onMount(() => {
    initApp()
  })
  return (
    <QueryClientProvider client={queryClient}>
      <ServiceRegistry>
        <Router>{routes}</Router>
      </ServiceRegistry>
    </QueryClientProvider>
  )
}

export default App
